if (!customElements.get('evrayne-finder')) {
 customElements.define('evrayne-finder', class extends HTMLElement {
  connectedCallback() {
   this.onChange=event=>{
    if(event.target.name==='ev-finder-goal') {
     this.querySelectorAll('[name="ev-finder-format"]').forEach(input=>input.checked=false);
     const goal=event.target.value;
     this.querySelectorAll('[data-finder-step]').forEach(step=>step.hidden=step.dataset.finderStep!==goal);
     this.querySelectorAll('[data-finder-category]').forEach(link=>link.hidden=link.dataset.finderCategory!==goal);
     this.querySelector('[data-finder-reset]').hidden=false;
     this.showResult(goal==='2'?'exfoliation':goal==='3'?'eye':'');
    } else if(event.target.name==='ev-finder-format') this.showResult(event.target.value);
   };
   this.onReset=()=>{
    this.querySelectorAll('input[type="radio"]').forEach(input=>input.checked=false);
    this.querySelectorAll('[data-finder-step],[data-finder-category]').forEach(item=>item.hidden=true);
    this.querySelector('[data-finder-reset]').hidden=true;
    this.showResult('');
    this.querySelector('[name="ev-finder-goal"]')?.focus();
   };
   this.addEventListener('change',this.onChange);
   this.querySelector('[data-finder-reset]').addEventListener('click',this.onReset);
  }
  showResult(key) {
   this.querySelectorAll('[data-finder-result]').forEach(result=>result.hidden=result.dataset.finderResult!==key);
   const result=[...this.querySelectorAll('[data-finder-result]')].find(item=>item.dataset.finderResult===key);
   this.querySelector('[data-finder-output]').hidden=!key;
   this.querySelector('[data-finder-compare]').hidden=key!=='exfoliation';
   this.querySelector('[data-finder-empty]').hidden=!key||Boolean(result?.querySelector('[data-finder-card]'));
  }
  disconnectedCallback(){this.removeEventListener('change',this.onChange);this.querySelector('[data-finder-reset]')?.removeEventListener('click',this.onReset);}
 });
}
